import { render, staticRenderFns } from "./energy-consumption.vue?vue&type=template&id=b3a55b7c&scoped=true&"
import script from "./energy-consumption.vue?vue&type=script&lang=js&"
export * from "./energy-consumption.vue?vue&type=script&lang=js&"
import style0 from "./energy-consumption.vue?vue&type=style&index=0&id=b3a55b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a55b7c",
  null
  
)

export default component.exports